import QuaterlyGoalTable from "./QuarterlyGoalTable/QuaterlyGoalTable";
import QuaterlyGoalFilterCard from "./QuaterlyGoalsFilter/QuaterlyGoalFilterCard";

import { useEffect, useState } from "react";
import { QuarterlySpeedGoalsEndPointLogic } from "../../../../../logic/AssetManagement/Health/Quarterly Website Speed Goals/QuarterlySpeedGoalsEndPointLogic";
import TableSkeleton from "../../../../TableSkeleton";
import { useSelector } from "react-redux";
import { selectUserToken } from "../../../../../features/userSlice";

function QuarterlyGoals() {
  const { selectedSharedUid } = useSelector(
    (state: any) => state.pageSpeedPerformance
  );
  const oauthTokenHeader = useSelector(selectUserToken) as any;
  const [loading, setLoading] = useState<boolean>(false);
  const [quarterlyGoalsData, setQuarterlyGoalsData] = useState([]) as any;
  const [, setErrorAccToPageStatus] = useState([]);

  useEffect(() => {
    const fetchQuarterlyGoalsData = async () => {
      if (selectedSharedUid) {
        setLoading(true);
        try {
          await QuarterlySpeedGoalsEndPointLogic.getQuarterlySpeedGoals(
            oauthTokenHeader,
            selectedSharedUid,
            setQuarterlyGoalsData,
            setErrorAccToPageStatus
          );
        } catch (error) {
          throw new Error("Error fetching goals");
        } finally {
          setLoading(false);
        }
      }
    };
    fetchQuarterlyGoalsData();
    // eslint-disable-next-line
  }, [selectedSharedUid, oauthTokenHeader]);

  const tableHeadings = {
    edit_page: "Edit",
    period: "Period",
    device: "Device",
    LCP: "LCP",
    INP: "INP",
    CLS: "CLS",
    FCP: "FCP",
    TTFB: "TTFB",
    mobile_speed_score: "Mobile Speed Score",
    requested_on: "Requested On",
    requested_by: "Requested By",
  };

  return (
    <>
      <QuaterlyGoalFilterCard
        tableData={quarterlyGoalsData?.data}
        setLoading={setLoading}
        loading={loading}
        quarterlyGoalsData={quarterlyGoalsData}
        setQuarterlyGoalsData={setQuarterlyGoalsData}
      />
      {loading ? (
        <TableSkeleton rows={10} columns={11} />
      ) : (
        <>
          <QuaterlyGoalTable
            tableHeadings={tableHeadings}
            quarterlyGoalsData={quarterlyGoalsData}
            setQuarterlyGoalsData={setQuarterlyGoalsData}
            setLoading={setLoading}
            loading={loading}
            tableData={quarterlyGoalsData?.data}
          />
        </>
      )}
    </>
  );
}

export default QuarterlyGoals;
